import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";
let cancel;
export default {
  getAllExternalTraining: function(params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/external-training" + params + "&include=file");
  },
  getExternalTraining: function(id, params) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/external-training/" + id + params
    );
  },
  removeExternalTraining: function(id) {
    return axios.delete(
      IMPROVE_CONFIG.API_URL + "/external-training/" + id
    );
  },
  removeExternalTrainingCertificate: function(id) {
      return axios.delete(
          IMPROVE_CONFIG.API_URL + "/external-training-certificate/" + id
          );
  },
  createExternalTraining: function(external, s3, file) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/external-training", {
      name: external.name,
      completed: external.completed,
      body: external.body,
      result: external.result,
      cost: external.cost,
      deadline: external.deadline,
      s3_url: s3,
      file: file,
      type: external.type,
      score: external.score
    });
  },
  updateExternalTraining: function(id, external, s3, file) {
    return axios.patch(IMPROVE_CONFIG.API_URL + "/external-training/" + id, {
      name: external.name,
      completed: external.completed,
      body: external.body,
      result: external.result,
      cost: external.cost,
      deadline: external.deadline,
      s3_url: s3,
      file: file,
      type: external.type,
      score: external.score
    });
  },
  createAdminExternalTraining: function(external, s3, file) {
        return axios.post(IMPROVE_CONFIG.API_URL + "/admin-external-training", {
            name: external.name,
            completed: external.completed,
            body: external.body,
            result: external.result,
            cost: external.cost,
            deadline: external.deadline,
            user: external.user,
            s3_url: s3,
            file: file,
            type: external.type,
            score: external.score
        });
    },
    editAdminExternalTraining: function(id, external, s3, file) {
        return axios.put(IMPROVE_CONFIG.API_URL + "/admin-external-training/" + id, {
            name: external.name,
            completed: external.completed,
            body: external.body,
            result: external.result,
            cost: external.cost,
            deadline: external.deadline,
            user: external.user,
            s3_url: s3,
            file: file,
            type: external.type,
            score: external.score
        });
    },
    getAdminExternalTraining: function(params, searchParams) {
        const CancelToken = axios.CancelToken;
        if (cancel !== undefined) {
         cancel();
        }
        return axios.get(IMPROVE_CONFIG.API_URL + "/admin-external-training" + params + searchParams + "&include=file,user",{
            cancelToken: new CancelToken((c) => {
                cancel = c;
            })
        });
    },
    importExternalTraining: function(file) {
        let formData = new FormData();
        formData.append('file', file);
        return axios.post(IMPROVE_CONFIG.API_URL + "/bulk-admin-external-training", formData, {
            headers: {
            'content-type': 'multipart/form-data; boundary=${formData._boundary}',
            },
        });
    },
    getErrorLogs: function(){
        return axios.get(IMPROVE_CONFIG.API_URL + "/user-error-logs?limit=10&container=External");
    },
    exportExternalTrainingCSV: function(params, search, type) {
        return axios.get(IMPROVE_CONFIG.API_URL + "/external-training-export" + params + search + type);
    },
    getExternalTrainingCategories: function(){
       return axios.get(IMPROVE_CONFIG.API_URL + "/get-external-training-categories");      
    },
    addExternalTrainingCategory: function(category) {
    return axios.post(
      IMPROVE_CONFIG.API_URL + "/external-training-category/add",
      {
        name: category.name,
      }
    );
  },
  deleteExternalTrainingCategory: function(id) {
    return axios.delete(IMPROVE_CONFIG.API_URL + "/delete-external-training-category/" + id);
  },
  updateExternalTrainingCategory: function(id, category) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/external-training-category/" + id, {
      name: category.name,
    });
  },

};
